module.exports = __webpack_public_path__ + "img/FIAT.4e9cb8a4.webp";